import React, {useState} from 'react'
import { useMutation } from "react-query";
import apiClient from "../../http-common";
import {
  triggerSuccess,
  triggerError,
  setErrorMessage,
  setSuccessMessage,
} from '../Request/StatusFormatter';

const CreateWallet = () => {    
const initialwallet = {
    name: '',
    address: '',
}
const [walletForm, setwalletForm] = useState(initialwallet);

const onChange = (e) =>
setwalletForm({ ...walletForm, [e.target.name]: e.target.value });

const { isLoading: isSendingRequest, mutate: postwallet } = useMutation(
    async () => {
      return await apiClient.post(`/api/create-wallet`, {
        name: walletForm.name,
        address: walletForm.address,
      });
    },
    {
      onSuccess: (res) => {
        setSuccessMessage(res.data);
        triggerSuccess(); 
      },
      onError: (err) => {
        setErrorMessage(err.response?.data || err);         
        triggerError();
      },
    }
  );


  return (
    <div id="admin-wallet-create-menu" className="offcanvas offcanvas-bottom offcanvas-attached">
            <div className="menu-size" style={{height: "640px"}}>
                <div className="d-flex mx-3 mt-3 py-1">
                    <div className="align-self-center">
                        <h1 className="mb-0">Create new Wallet</h1>
                    </div>
                    <div className="align-self-center ms-auto">
                        <a href="/#" className= "ps-4 shadow-0 me-n2" data-bs-dismiss="offcanvas">
                            <i className="bi bi-x color-red-dark font-26 line-height-xl"></i>
                        </a>
                    </div>
                </div>
                <div className="divider divider-margins mt-3"></div>
                <form className="content mt-0">
                <div className="pb-2"></div>
                        <div className="form-custom form-label form-icon">
                            <i className="bi bi-code font-14"></i>
                            <input onChange={onChange} type="text" name="name" className="form-control rounded-xs bg-theme color-theme" id="name" placeholder="wallet name"/>
                            <label htmlFor="name" className="color-highlight form-label-always-">Wallet Name</label>
                            <span>(Wallet Name)</span>
                        </div>
                        <div className="pb-2"></div>

                        <div className="form-custom form-label form-icon">
                            <i className="bi bi-code font-14"></i>
                            <textarea onChange={onChange} type="text" name="address" className="form-control rounded-xs bg-theme color-theme" id="address" placeholder="address"></textarea>
                            <label htmlFor="address" className="color-highlight form-label-always-">address</label>
                            <span>(address)</span>
                        </div>
                        <div className="pb-2"></div>

                        <div onClick={postwallet} className="btn btn-full gradient-green rounded-s shadow-bg shadow-bg-s mb-4">
                            {isSendingRequest? <span>creating...</span>
                            :
                            <span>Create wallet</span>
                            }                            
                        </div>                     
                </form>                
            </div>
        </div>
  )
}

export default CreateWallet